import type { InputProps } from '@nuxt/ui'

const bigInput: NonNullable<InputProps['ui']> = {
  leadingIcon: 'size-6',
  base: 'bg-white text-gray-900 ring-0 ring-inset ring-gray-300 focus:ring-2 focus:ring-primary-500 text-base font-bold leading-6 h-[72px]',
}

const bigInputDark: NonNullable<InputProps['ui']> = {
  leadingIcon: 'size-6',
  base: 'bg-white text-gray-900 ring-0 ring-inset ring-gray-300 focus:ring-2 focus:ring-primary-500 text-base font-bold leading-6 h-[72px] placeholder:text-gray-900',
}

export { bigInput, bigInputDark }
